import {gsap} from "gsap";


const animationOnce = (container) => {
    // console.log("Projects animation ONCE");

    // Element à animer
    const projects_li = container.querySelectorAll("#projects-list li");
    const scroll_link = container.querySelector("#scrollToContentLink");
    gsap.set(scroll_link, {alpha:0, y:120})
    gsap.set(projects_li, {alpha:0, scale:.9})
    gsap.set(container, {alpha:1})

    // Gsap timeline
    const tl = gsap.timeline({
        defaults : {
            duration: 1,
            ease: "power3.out",
        },
        delay:.8,
    });

    tl.to(projects_li, {alpha:1, scale:1,  duration:.6,ease: "power1.inout",stagger: { // wrap advanced options in an object
            amount: 0.2,
            from: "center",
            ease: "power2.inOut",
        }})
        .to(scroll_link, {alpha:1, y:0, ease:'back.out'}, '+=.3');


    //pour dev
    tl.timeScale( 1 );
    return tl;
}

export default animationOnce;
